import { useRouter } from 'next/router';
import { Dispatch, useCallback, useMemo } from 'react';
import { isSkillup } from '../config/project/project';
import useUpdateRouter from './updateRouter';
import { useRegion } from '../providers/regionProvider';

const useSeeAllReuslts = (
  setPage: Dispatch<number>,
  potentialFilters: any,
  page: 'careers' | 'open-jobs' | 'training' | 'careerguide',
) => {
  const router = useRouter();
  const { updateRouter } = useUpdateRouter();
  const {
    region: { slug },
  } = useRegion();

  const pathname = useMemo(() => {
    if (isSkillup) {
      return `/${slug}/${page}`;
    }

    return `/${page}`;
  }, [slug]);

  const seeAllResults = useCallback(() => {
    const { sortBy, search, location } = router.query;
    delete potentialFilters[':region'];
    setPage(1);
    updateRouter({
      pathname,
      query: {
        // ...router.query,
        ...potentialFilters,
        ...(sortBy ? { sortBy } : {}),
        ...(search ? { search } : {}),
        ...(location ? { location } : {}),
      },
      hash: 'results',
    });
  }, [router, potentialFilters]);

  return { seeAllResults };
};

export default useSeeAllReuslts;
